import _ from 'lodash';
import events from './events.json';

const registerEvents = _.noop;

export { events, registerEvents };
